<template>
  <df-messenger
    intent="WELCOME"
    :chat-icon="require('../../assets/image/speak.png')"
    chat-title="BronskyBot"
    agent-id="12efffd8-3ba8-404f-8f6b-125ba5cc0a1f"
    language-code="en"
  ></df-messenger>
</template>

<script>
export default {
  name: "ChatBot",
};
</script>

<style scoped>
df-messenger {
  --df-messenger-bot-message: #878fac;
  --df-messenger-button-titlebar-color: #8f2b3c;
  --df-messenger-chat-background-color: #eff4f7;
  --df-messenger-font-color: white;
  --df-messenger-send-icon: #ffbe28;
  --df-messenger-user-message: #1e2f4a;
  --df-messenger-minimized-chat-close-icon-color: #ffbe28;
  --df-messenger-button-titlebar-font-color: #ffbe28;
}
</style>
